<template>
  <div class="app-container">
    <el-card class="LMSearch">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item>
              <template slot="label">
                <div class="searchNumberType">
                  <el-select v-model="queryForm.params.numberType">
                    <!--运单号-->
                    <el-option :label="$t('newOrder.waybillNumber')" :value="1" />
                    <!--扫描单号-->
                    <el-option :label="$t('placeOrder.scanOrderNumber')" :value="2" />
                  </el-select>
                </div>
              </template>
              <el-input
                v-model="queryForm.params.waybillNumbers"
                :placeholder="$t('collectionCenter.max2000Line')"
                :rows="1"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!--定责时间-->
            <el-form-item :label="$t('fixDutyFine.DefiniteTime')">
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--定责类型-->
            <el-form-item :label="$t('fixDutyFine.DefiniteType')">
              <el-select
                v-model="queryForm.params.responsibilityTypeList"
                :placeholder="$t('collectionCenter.tudo')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in responsibilityTypeList.ResponsibilityType"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--定责环节-->
            <el-form-item :label="$t('fixDutyFine.DefiniteLink')">
              <el-select
                v-model="queryForm.params.responsibilityStageList"
                :placeholder="$t('collectionCenter.tudo')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in responsibilityTypeList.ResponsibilityStage"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <!--责任方-->
            <el-form-item :label="$t('fixDutyFine.ResponsibleParty')">
              <el-select
                v-model="queryForm.params.responsibilityParty"
                :placeholder="$t('collectionCenter.tudo')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('fixDutyFine.trunkLine')" :value="1" />
                <el-option key="2" :label="$t('orderCenterCont.region')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 责任网点 -->
            <el-form-item :label="$t('fixDutyFine.ResponsibleBranch')">
              <el-select
                v-model="queryForm.params.siteIdList"
                :placeholder="$t('collectionCenter.tudo')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--大区-->
            <el-form-item :label="$t('collectionCenter.region')">
              <el-select
                v-model="queryForm.params.regionId"
                :placeholder="$t('collectionCenter.tudo')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--网点所属州-->
            <el-form-item :label="$t('collectionCenter.stateSite1')">
              <el-select
                v-model="queryForm.params.stateList"
                :placeholder="$t('collectionCenter.tudo')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in stateOptionList"
                  :key="item.twoCode"
                  :label="item.twoCode"
                  :value="item.twoCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--所属转运中心-->
            <el-form-item :label="$t('collectionCenter.owningTransitCenter1')">
              <el-select
                v-model="queryForm.params.transitCenterIdList"
                :placeholder="$t('collectionCenter.tudo')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in transitCenterOptionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--客户-->
            <el-form-item :label="$t('collectionCenter.client')">
              <el-select
                v-model="queryForm.params.customerIdList"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @focus="getCustomerPage()"
                @change="getMerchantList"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--商户-->
            <el-form-item :label="$t('collectionCenter.CommercialOwner')">
              <el-select
                v-model="queryForm.params.merchantCodeList"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
                :disabled="!queryForm.params.customerIdList || queryForm.params.customerIdList.length === 0"
              >
                <el-option
                  v-for="(item, index) in merchantList"
                  :key="index"
                  :label="item.merchantName + '（' + item.merchantCode + '）'"
                  :value="item.merchantCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" style="margin-top: 10px">
            <el-button
              size="small" type="primary" @click="getTableData"
            >{{ $t('collectionCenter.search') }}
            </el-button>
            <el-button
              plain size="small" @click="resetSearch"
            >{{ $t('collectionCenter.reset') }}
            </el-button>
            <el-radio-group
              v-model="queryForm.params.isTest"
              size="small"
              style="margin-left: 10px"
            >
              <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
              <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
            </el-radio-group>

            <!--批量导出单号-->
            <el-button
              size="small" style="margin-left: 10px"
              @click="orderNumberExport"
            >{{ $t('placeOrder.BatchExport') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="LMTable">
      <div style="margin-bottom: 10px">
        <el-table
          :data="deductionAmountData"
          :header-cell-style="{ background: '#f2f2f2', color: 'black', textAlign: 'center' }"
          border
        >
          <el-table-column align="center" label="" prop="numberVotes" />
          <el-table-column
            v-for="(item, index) in tableColumn1"
            :key="index"
            :align="item.align"
            :class-name="item.className"
            :label="item.label"
            :prop="item.prop"
          >
            <template slot-scope="scope">
              <div style="cursor: pointer" @click="getResponsibilityType(item.prop, 1)">
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-bottom: 10px">
        <el-table
          :data="tableData1"
          :header-cell-style="{ background: '#f2f2f2', color: 'black', textAlign: 'center' }"
          border
        >
          <el-table-column
            v-for="(item, index) in tableColumn2"
            :key="index"
            :align="item.align"
            :class-name="item.className"
            :label="item.label"
            :prop="item.prop"
          >
            <template slot-scope="scope">
              <div style="cursor: pointer" @click="getResponsibilityType(item.prop, 2)">
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-bottom: 10px">
        <div>
          {{ $t('navbar.gong') }} <span style="color: #409eff">{{ total }}</span>
          {{ $t('fixDutyFine.Item') }}
          <!--批量导入-->
          <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="openBatchImportWindow"
          >{{ $t('navbar.orderImport') }}
          </el-button>
          <!--修改定责-->
          <el-button
            plain size="small" @click="openChangeWindow"
          >{{ $t('fixDutyFine.modifyResponsibility') }}
          </el-button>
          <!--导出-->
          <el-button
            size="small" style="float: right" type="primary"
            @click="exportExcel"
          >{{ $t('collectionCenter.export') }}
          </el-button>
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#f2f2f2', color: 'black', textAlign: 'center' }"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column align="center" type="selection" width="50" />
          <el-table-column
            v-for="(item, index) in tableColumn"
            :key="index"
            :align="item.align"
            :class-name="item.className"
            :label="item.label"
            :min-width="item.width"
            :prop="item.prop"
          >
            <template slot-scope="scope">
              <div
                v-if="item.prop === 'waybillNumber'"
                style="cursor: pointer"
                @click="toOrderDetail(scope.row)"
              >
                {{ scope.row.waybillNumber }}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 50, 100, 200, 400]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 20px 0; text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    <!--批量导入-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('placeOrder.orderImport')"
      :visible.sync="isBatchImportWindow"
      width="600px"
    >
      <div>
        <batchImport
          :key="isBatchImportWindow"
          ref="batchImport"
          :branch-enable-list="branchEnableList"
          :import-type="importType"
          :responsibility-type-list="responsibilityTypeList"
          :site-id-list="siteIdList"
          @confirmImportData="confirmImportData"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <div v-if="importType === 1">
          <el-button
            size="small" @click="isBatchImportWindow = false"
          >{{ $t('GlobalSetObj.Cancelar') }}
          </el-button>
          <el-button size="small" type="primary" @click="confirmImport">
            {{ $t('GlobalSetObj.confirm') }}
          </el-button>
        </div>
        <div v-else-if="importType === 2">
          <el-button
            size="small" @click="isBatchImportWindow = false"
          >{{ $t('GlobalSetObj.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!--修改定责-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('fixDutyFine.modifyResponsibility')"
      :visible.sync="isChangeWindow"
      width="600px"
    >
      <div>
        <changeSite
          :key="isChangeWindow"
          ref="changeWindow"
          :branch-enable-list="branchEnableList"
          :change-type="changeType"
          :responsibility-type-list="responsibilityTypeList"
          :selected-data="selectedData"
          :site-id-list="siteIdList"
          @changeSiteData="changeSiteData"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <div v-if="changeType === 1">
          <el-button
            size="small" @click="isChangeWindow = false"
          >{{ $t('GlobalSetObj.Cancelar') }}
          </el-button>
          <el-button size="small" type="primary" @click="confirmChange">
            {{ $t('GlobalSetObj.confirm') }}
          </el-button>
        </div>
        <div v-else-if="changeType === 2">
          <el-button
            size="small" @click="isChangeWindow = false"
          >{{ $t('GlobalSetObj.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!--运单详情-->
    <el-drawer
      :append-to-body="true"
      :title="$t('orderCenterCont.LogisticsOrders')"
      :visible.sync="waybillDescription"
      custom-class="drawerClass"
      direction="ltr"
      size="90%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <waybill-information :key="showQueryTrack.trackKey" :query-track-param="TrackParam" />
      </div>
    </el-drawer>

    <!--  批量单号导出 -->
    <exportOrderNumber ref="exportOrderNumberRef" />
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { siteQueryOwnSite } from '@/api/lanshou';
import batchImport from './cmp/batchImport.vue';
import changeSite from './cmp/changeSite.vue';
import exportOrderNumber from './cmp/exportOrderNumber.vue';
import { goResourceTaskList } from '@/utils/goExportList';
import {
  lmLossResponsibilityExport,
  lmLossResponsibilityGetDropdownOptions,
  lmLossResponsibilityGetStateOptions,
  lmLossResponsibilityGetTransferCenterOptions,
  lmLossResponsibilityPage,
  lmLossResponsibilityStatistics
} from '@/api/definiteResponsibilityAndPenalty';
import { getqueryAll } from '@/api/automaticSorting';
import waybillInformation from '@/views/orderCenter/logisticsOrders/components/waybillInformation/waybillInformation.vue';
import { regionQueryList, getMerchantByCustomerIdList } from '@/api/orderApi';
import { apiCustomerPage } from '@/api/customer';

export default {
  name: 'LMLiabilityForLosses',
  components: {
    waybillInformation,
    batchImport,
    changeSite,
    exportOrderNumber
  },
  data() {
    return {
      merchantList: [], // 商户列表
      customerList: [], // 客户列表
      sitesByRegionAndState: {},
      regionList: [],
      timeValue: [],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          waybillNumbers: '',
          numberType: 1,
          responsibilityTypeList: [],
          responsibilityStageList: [],
          siteIdList: [],
          responsibilityStartTime: '',
          responsibilityEndTime: '',
          isTest: 1,
          regionId: '',
          stateList: [],
          transitCenterIdList: [],
          responsibilityParty: '',
          customerIdList: [],
          merchantCodeList: []
        }
      },
      siteIdList: [],
      tableData1: [],
      tableColumn1: [
        // 全部
        {
          label: this.$t('collectionCenter.tudo'),
          prop: 'total',
          align: 'center',
          className: 'primary'
        },
        // 确认丢失
        {
          label: this.$t('operationTips.confirmLost'),
          prop: 'confirmedLost',
          align: 'center',
          className: 'primary'
        },
        // 被偷或被抢
        {
          label: this.$t('fixDutyFine.StolenOrRobbed'),
          prop: 'stolenOrRobbed',
          align: 'center',
          className: 'primary'
        },
        // 破损
        {
          label: this.$t('fixDutyFine.Damage'),
          prop: 'damaged',
          align: 'center',
          className: 'primary'
        },
        // 投诉工单
        {
          label: this.$t('RouterObj.ComplaintWorkOrder'),
          prop: 'complaintWorkOrderCount',
          align: 'center',
          className: 'primary'
        },
        // 平台投诉   ===>  社媒升级投诉
        {
          label: this.$t('tablePrice.socialMediaEscalatedComplaint'),
          prop: 'platformComplaints',
          align: 'center',
          className: 'primary'
        },
        // POD不规范
        {
          label: this.$t('fixDutyFine.PODIrregular'),
          prop: 'podIrregularities',
          align: 'center',
          className: 'primary'
        },
        // 超时未闭环
        {
          label: this.$t('compensationManagement.TimeoutNotClosedLoop'),
          prop: 'overtimeNotClosed',
          align: 'center',
          className: 'primary'
        }
      ],
      tableColumn2: [
        // TFK
        {
          label: 'TFK',
          prop: 'tfk',
          align: 'center',
          className: 'primary'
        },
        // 揽收
        {
          label: this.$t('collectionCenter.lanshou'),
          prop: 'collection',
          align: 'center',
          className: 'primary'
        },
        // 运输
        {
          label: this.$t('home.transportation'),
          prop: 'transportation',
          align: 'center',
          className: 'primary'
        },
        // 分拣
        { label: this.$t('home.sorting'), prop: 'sorting', align: 'center', className: 'primary' },
        // 派送
        {
          label: this.$t('collectionCenter.dispatch'),
          prop: 'delivery',
          align: 'center',
          className: 'primary'
        }
      ],
      tableColumn: [
        // 运单号
        {
          label: this.$t('newOrder.waybillNumber'),
          prop: 'waybillNumber',
          align: 'center',
          width: 180,
          className: 'primary'
        },
        // 扫描单号
        {
          label: this.$t('placeOrder.scanOrderNumber'),
          prop: 'scanOrderNumber',
          align: 'center',
          width: 180
        },
        // 定责类型
        {
          label: this.$t('fixDutyFine.DefiniteType'),
          prop: 'responsibilityTypeName',
          align: 'center',
          width: 180
        },
        // 定责时间
        {
          label: this.$t('fixDutyFine.DefiniteTime'),
          prop: 'responsibilityTime',
          align: 'center',
          width: 180
        },
        // 定责人
        {
          label: this.$t('fixDutyFine.DefinitePerson'),
          prop: 'responsibilityUser',
          align: 'center',
          width: 180
        },
        // 责任方
        {
          label: this.$t('fixDutyFine.ResponsibleParty'),
          prop: 'responsibilityPartyStr',
          align: 'center',
          width: 160
        },
        // 责任环节
        {
          label: this.$t('fixDutyFine.ResponsibleLink'),
          prop: 'responsibilityStageName',
          align: 'center',
          width: 180
        },
        // 责任方
        {
          label: this.$t('fixDutyFine.ResponsibleBranch'),
          prop: 'siteName',
          align: 'center',
          width: 180
        },
        // 大区
        { label: this.$t('collectionCenter.region'), prop: 'region', align: 'center', width: 150 },
        // 网点所属州
        {
          label: this.$t('collectionCenter.stateSite1'),
          prop: 'state',
          align: 'center',
          width: 180
        },
        // 所属转运中心
        {
          label: this.$t('collectionCenter.owningTransitCenter1'),
          prop: 'departmentName',
          align: 'center',
          width: 170
        },
        // 客户
        {
          label: this.$t('collectionCenter.client'),
          prop: 'customerName',
          align: 'center',
          width: 180
        },
        // 商户
        {
          label: this.$t('collectionCenter.CommercialOwner'),
          prop: 'merchantName',
          align: 'center',
          width: 180
        },
        // 预计扣罚金额
        {
          label: this.$t('fixDutyFine.EstimatedPenaltyAmount'),
          prop: 'preFineAmount',
          align: 'center',
          width: 170
        },
        // 最新轨迹时间
        {
          label: this.$t('orderCenterCont.TheLatestTraceTime'),
          prop: 'latestTrackTime',
          align: 'center',
          width: 170
        },
        // 最新轨迹内容
        {
          label: this.$t('orderCenterCont.zuixinguijineir'),
          prop: 'latestTrackContent',
          align: 'center',
          width: 170
        },
        // 最新轨迹网点
        {
          label: this.$t('fixDutyFine.LatestTrackingBranch'),
          prop: 'latestTrackSite',
          align: 'center',
          width: 180
        },
        // 次新轨迹时间
        {
          label: this.$t('fixDutyFine.SecondaryNewTrackingTime'),
          prop: 'secondNewestTrackTime',
          align: 'center',
          width: 180
        },
        // 次新轨迹内容
        {
          label: this.$t('fixDutyFine.SecondaryNewTrackingContent'),
          prop: 'secondNewestTrackContent',
          align: 'center',
          width: 180
        },
        // 次新轨迹网点
        {
          label: this.$t('fixDutyFine.SecondaryNewTrackingBranch'),
          prop: 'secondNewestTrackSite',
          align: 'center',
          width: 180
        }
      ],
      tableData: [],
      selectedData: [],
      total: 0,
      isBatchImportWindow: false,
      isChangeWindow: false,
      changeType: 1,
      importType: 1,
      responsibilityTypeList: [],
      branchEnableList: [],
      waybillDescription: false,
      showQueryTrack: {
        visible: false,
        trackKey: new Date().getTime()
      },
      TrackParam: {},
      stateOptionList: [],
      transitCenterOptionList: [],
      responsibility: null,
      responsibilityType: null,
      deductionAmountData: []
    };
  },

  watch: {
    'queryForm.params.regionId'(newVal) {
      this.queryForm.params.stateList = [];
      if (newVal && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === newVal);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.stateOptionList = selectedRegion.states.map((twoCode) => ({ twoCode }));
        }
      } else {
        this.stateOptionList = [];
        this.getStateSiteList();
      }
    }
  },
  created() {
    // 获取大区选项
    this.getRegion();
    // 获取网点所属州
    this.getStateSiteList();
    // 获取网点所属转运中心
    this.getTransitCenterList();
    // 初始化时间
    this.initTime();
    // 查询列表
    this.getTableData();
    // 获取所有网点
    this.getBranchList();
    // 定责类型
    this.getResponsibilityTypeList();
    // 启用的网点
    this.getBranchEnableList();
  },
  methods: {
    orderNumberExport() {
      // 调用子组件
      this.$refs.exportOrderNumberRef.handleOpen();
    },
    getMerchantList(val) {
      if (!val || val.length === 0) {
        this.queryForm.params.merchantCodeList = [];
        this.merchantList = [];
        return;
      }
      const form = {
        customerIdList: val
      };
      getMerchantByCustomerIdList(form).then(res => {
        if (res.code === 200) {
          this.merchantList = res.data;
        }
      });
    },
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 大区
    getRegion() {
      regionQueryList(3).then((res) => {
        if (res.code === 200) {
          const processedData = res.data.map((region) => ({
            ...region,
            transitCenters: region.transitCenters.map((site) => ({
              ...site,
              id: site.departmentId // 将 id 替换为 departmentId
            }))
          }));
          this.regionList = processedData;
        }
      });
    },
    // 定责类型查询
    getResponsibilityType(data, type) {
      this.responsibility = data;
      this.responsibilityType = type;
      this.queryForm.pageNumber = 1;
      this.getParamData();
    },
    getParamData() {
      const queryParam = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.queryParam()
      };
      if (this.responsibilityType === 1) {
        switch (this.responsibility) {
          case 'total': // 全部
            queryParam.params.responsibilityTypeList = [];
            break;
          case 'confirmedLost': // 确认丢失
            queryParam.params.responsibilityTypeList = [1];
            break;
          case 'stolenOrRobbed': // 被偷或被抢
            queryParam.params.responsibilityTypeList = [2];
            break;
          case 'damaged': // 破损
            queryParam.params.responsibilityTypeList = [3];
            break;
          case 'complaintWorkOrderCount': // 虚假签收
            queryParam.params.responsibilityTypeList = [4, 5, 6];
            break;
          case 'platformComplaints': // 平台投诉
            queryParam.params.responsibilityTypeList = [7];
            break;
          case 'podIrregularities': // POD不规范
            queryParam.params.responsibilityTypeList = [9];
            break;
          case 'overtimeNotClosed': // 超时未闭环
            queryParam.params.responsibilityTypeList = [8];
            break;
        }
      } else if (this.responsibilityType === 2) {
        switch (this.responsibility) {
          case 'collection': // 揽收
            queryParam.params.responsibilityStageList = [1];
            break;
          case 'transportation': // 运输
            queryParam.params.responsibilityStageList = [2];
            break;
          case 'sorting': // 分拣
            queryParam.params.responsibilityStageList = [3];
            break;
          case 'delivery': // 派送
            queryParam.params.responsibilityStageList = [4];
            break;
          case 'tfk':
            queryParam.params.responsibilityStageList = [5];
            break;
          // 可选：添加default分支处理未匹配的情况
          default:
            queryParam.params.responsibilityStageList = []; // 或其他默认值
            break;
        }
      }
      // 分页
      lmLossResponsibilityPage(queryParam).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 获取网点所属州
    getStateSiteList() {
      const param = {
        level: 0,
        parentId: '',
        stateList: this.queryForm.params.regionId || []
      };
      lmLossResponsibilityGetStateOptions(param).then((res) => {
        if (res.code === 200) {
          this.stateOptionList = res.data;
        }
      });
    },
    // 获取网点所属转运中心
    getTransitCenterList() {
      let stateList = [];
      if (this.queryForm.params.stateList && this.queryForm.params.stateList.length > 0) {
        stateList = this.queryForm.params.stateList;
      } else {
        if (this.stateOptionList && this.stateOptionList.length > 0) {
          stateList = this.stateOptionList.map((item) => {
            return item.twoCode;
          });
        }
      }
      const param = {
        stateList: stateList
      };
      lmLossResponsibilityGetTransferCenterOptions(param).then((res) => {
        if (res.code === 200) {
          this.transitCenterOptionList = res.data;
        }
      });
    },
    // 进入运单详情
    toOrderDetail(row) {
      this.TrackParam = row;
      this.TrackParam.LM = 1;
      this.showQueryTrack.trackKey = new Date().getTime();
      this.waybillDescription = true;
    },
    // 查询所有启用的网点
    getBranchEnableList() {
      getqueryAll().then((res) => {
        if (res.code === 200) {
          this.branchEnableList = res.data;
        }
      });
    },
    // 获取定责类型
    getResponsibilityTypeList() {
      lmLossResponsibilityGetDropdownOptions().then((res) => {
        if (res.code === 200) {
          this.responsibilityTypeList = res.data;
        }
      });
    },
    // 列表数据选择
    handleSelectionChange(data) {
      this.selectedData = data;
      console.log(this.selectedData, '===this.selectedData');
    },
    // 确认修改
    confirmChange() {
      this.$refs.changeWindow.changeSite();
    },
    // 修改完成
    changeSiteData() {
      this.changeType = 2;
      this.getTableData();
    },
    // 确认导入
    confirmImport() {
      this.$refs.batchImport.confirmImport();
    },
    // 导入完成
    confirmImportData() {
      this.importType = 2;
      this.getTableData();
    },
    // 导出
    exportExcel() {
      const exportParam = this.queryParam();
      if (this.responsibilityType === 1) {
        switch (this.responsibility) {
          case 'total': // 全部
            exportParam.responsibilityTypeList = [];
            break;
          case 'confirmedLost': // 确认丢失
            exportParam.responsibilityTypeList = [1];
            break;
          case 'stolenOrRobbed': // 被偷或被抢
            exportParam.responsibilityTypeList = [2];
            break;
          case 'damaged': // 破损
            exportParam.responsibilityTypeList = [3];
            break;
          case 'complaintWorkOrderCount': // 虚假签收
            exportParam.responsibilityTypeList = [4, 5, 6];
            break;
          case 'platformComplaints': // 平台投诉
            exportParam.responsibilityTypeList = [7];
            break;
          case 'podIrregularities': // POD不规范
            exportParam.responsibilityTypeList = [9];
            break;
          case 'overtimeNotClosed': // 超时未闭环
            exportParam.responsibilityTypeList = [8];
            break;
        }
      } else if (this.responsibilityType === 2) {
        switch (this.responsibility) {
          case 'collection': // 揽收
            exportParam.responsibilityStageList = [1];
            break;
          case 'transportation': // 运输
            exportParam.responsibilityStageList = [2];
            break;
          case 'sorting': // 分拣
            exportParam.responsibilityStageList = [3];
            break;
          case 'delivery': // 派送
            exportParam.responsibilityStageList = [4];
            break; // 新增break，防止穿透到下一个case
          case 'tfk':
            exportParam.responsibilityStageList = [5];
            break;
          // 可选：添加default分支处理未匹配的情况
          default:
            exportParam.responsibilityStageList = []; // 或其他默认值
            break;
        }
      }
      console.log(exportParam, '====exportParam');
      if (this.tableData.length > 0) {
        lmLossResponsibilityExport(exportParam).then((res) => {
          if (res.code === 200) {
            goResourceTaskList();
          }
        });
      } else {
        this.$message.warning(this.$t('collectionCenter.noDataExport'));
      }
    },
    // 打开修改网点弹窗
    openChangeWindow() {
      if (this.selectedData.length > 0) {
        this.changeType = 1;
        this.isChangeWindow = true;
      } else {
        this.$message.warning(this.$t('orderCenterCont.SelectAtLeastOnePieceOfData'));
      }
    },
    // 打开批量导入弹窗
    openBatchImportWindow() {
      this.importType = 1;
      this.isBatchImportWindow = true;
    },
    // 查询条件整理
    queryParam() {
      const params = {
        waybillNumberList: [],
        scanOrderNumberList: [],
        responsibilityTypeList: this.queryForm.params.responsibilityTypeList || [],
        responsibilityStageList: this.queryForm.params.responsibilityStageList || [],
        siteIdList: this.queryForm.params.siteIdList || [],
        responsibilityStartTime: '',
        responsibilityEndTime: '',
        isTest: this.queryForm.params.isTest,
        regionId: this.queryForm.params.regionId || '',
        responsibilityParty: this.queryForm.params.responsibilityParty,
        stateList: this.queryForm.params.stateList || [],
        transitCenterIdList: this.queryForm.params.transitCenterIdList || [],
        customerIdList: this.queryForm.params.customerIdList,
        merchantCodeList: this.queryForm.params.merchantCodeList
      };
      if (this.queryForm.params.waybillNumbers) {
        const num = this.queryForm.params.waybillNumbers.split(/([\n\r])/);
        num.map((item) => {
          const reg = /\s/g;
          const a = item.replace(reg, '');
          const b = a.trim();
          if (b) {
            if (this.queryForm.params.numberType === 1) {
              params.waybillNumberList.push(b);
            } else {
              params.scanOrderNumberList.push(b);
            }
          }
        });
      }
      if (this.timeValue && this.timeValue.length > 1) {
        params.responsibilityStartTime = this.timeValue[0];
        params.responsibilityEndTime = this.timeValue[1];
      }
      return params;
    },
    // 查询
    getTableData() {
      const queryParam = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.queryParam()
      };
      if (!this.timeValue && !this.queryForm.params.waybillNumbers) {
        this.$message.warning(this.$t('receivablePayable.SearchTimeCannotBeEmpty'));
        return;
      }
      if (queryParam.params.waybillNumberList.length > 2000) {
        this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      this.responsibility = null;
      this.responsibilityType = null;
      // 分页
      lmLossResponsibilityPage(queryParam).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
      // 统计
      lmLossResponsibilityStatistics(queryParam.params).then((res) => {
        if (res.code === 200) {
          this.tableData1 = [res.data];
          this.deductionAmountData = [
            {
              numberVotes: this.$t('collectionCenter.ballot'), // '票数',
              total: res.data.total,
              confirmedLost: res.data.confirmedLost,
              stolenOrRobbed: res.data.stolenOrRobbed,
              damaged: res.data.damaged,
              complaintWorkOrderCount: res.data.complaintWorkOrderCount,
              platformComplaints: res.data.platformComplaints,
              podIrregularities: res.data.podIrregularities,
              overtimeNotClosed: res.data.overtimeNotClosed
            },
            {
              numberVotes: this.$t('fixDutyFine.EstimatedPenaltyAmount'), // '预计扣罚金额',
              total: 'R$ ' + res.data.totalAmount,
              confirmedLost: 'R$ ' + res.data.confirmedLostAmount,
              stolenOrRobbed: 'R$ ' + res.data.stolenOrRobbedAmount,
              damaged: 'R$ ' + res.data.damagedAmount,
              complaintWorkOrderCount: 'R$ ' + res.data.complaintWorkOrderAmount,
              platformComplaints: 'R$ ' + res.data.platformComplaintsAmount,
              podIrregularities: 'R$ ' + res.data.podIrregularitiesAmount,
              overtimeNotClosed: 'R$ ' + res.data.overtimeNotClosedAmount
            }
          ];
        }
      });
    },
    // 重置
    resetSearch() {
      this.queryForm.pageNumber = 1;
      this.queryForm.params = {
        numberType: 1,
        waybillNumbers: '',
        responsibilityTypeList: [],
        responsibilityStageList: [],
        siteIdList: [],
        responsibilityStartTime: '',
        responsibilityEndTime: '',
        isTest: 1,
        regionId: '',
        responsibilityParty: '',
        stateList: [],
        transitCenterIdList: [],
        customerIdList: [],
        merchantCodeList: []
      };
      // 获取网点所属州
      this.getStateSiteList();
      // 获取网点所属转运中心
      this.getTransitCenterList();
      this.initTime();
      this.getTableData();
    },
    // 初始化时间
    initTime() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD'); // 获取当前日期
      const threeDaysAgo = dayjs(brazilTime).subtract(2, 'day').format('YYYY-MM-DD'); // 三天前日期
      this.timeValue = [threeDaysAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    // 查询所有网点
    getBranchList() {
      siteQueryOwnSite().then((res) => {
        if (res.code === 200) {
          this.siteIdList = res.data;
        }
      });
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      if (this.responsibilityType) {
        this.getParamData();
      } else {
        this.getTableData();
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      if (this.responsibilityType) {
        this.getParamData();
      } else {
        this.getTableData();
      }
    }
  }
};
</script>

<style>
.LMSearch .el-form-item--mini.el-form-item,
.LMSearch .el-form-item--small.el-form-item {
  margin-bottom: 0;
}

.LMSearch .el-form-item__label .searchNumberType .el-input__inner {
  border: 0;
  font-weight: bold;
  padding: 0;
}

.el-table .primary {
  color: #409eff;
}

.el-table .danger {
  color: #f56c6c;
}
</style>
